// extracted by mini-css-extract-plugin
export default {"buttonCollapse":"window-control_buttonCollapse__wcE4y","buttonExpand":"window-control_buttonExpand__pbePh","buttonClose":"window-control_buttonClose__7Z+uU"};